// extracted by mini-css-extract-plugin
export default {"ModalText":"DeleteBusinessModal_ModalText__YxQTo"};